import { render } from "./handleFileAction.vue?vue&type=template&id=601c4d30"
import script from "./handleFileAction.vue?vue&type=script&lang=js"
export * from "./handleFileAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__